export const iconFontAwesomeSciencefictionRocket = (
	<i className="fa-solid fa-rocket"></i>
);
